import React from "react";
import NuotoCorsiSezioniDue from "../../components/corsi_nuoto/NuotoCorsiSezioni";
import CaroselloStandard from "../../commons/CaroselloStandard";
import foto1 from "../../images/corsiNuoto/standard1.jpeg"
import foto2 from "../../images/corsiNuoto/piscina_g.jpeg"
import foto3 from "../../images/corsiNuoto/istruttori.jpeg";




function NuotoCorsi() {
    return(
        <div>
            <div className="title d-flex flex-row m-4">
                <p className="display-4 fw-bold m-auto" style={{color: "#41B6F4"}}>CORSI DI NUOTO</p>
            </div>
            <CaroselloStandard foto1={foto1} foto2={foto2} foto3={foto3} />
            <hr/>
            <figure className="text-center">
                <blockquote className="blockquote">
                    <p>Inserire testo...</p>
                </blockquote>
            </figure>
            <hr/>
            <NuotoCorsiSezioniDue />
            <hr/>
        </div>
    )
}


export default NuotoCorsi
